import { useState, useEffect } from 'react';

const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
    screenHeight: typeof window !== 'undefined' ? window.innerHeight : 1080,
    pixelRatio: typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1,
    isPortrait: typeof window !== 'undefined' ? window.innerHeight > window.innerWidth : false
  });

  useEffect(() => {
    const getDeviceType = (width) => {
      if (width <= 768) return 'mobile';
      if (width <= 1024) return 'tablet';
      return 'desktop';
    };

    const updateDeviceInfo = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const deviceType = getDeviceType(width);

      setDeviceInfo({
        isMobile: deviceType === 'mobile',
        isTablet: deviceType === 'tablet',
        isDesktop: deviceType === 'desktop',
        screenWidth: width,
        screenHeight: height,
        pixelRatio: window.devicePixelRatio || 1,
        isPortrait: height > width
      });
    };

    // Initial detection
    updateDeviceInfo();

    // Add event listener for window resize
    window.addEventListener('resize', updateDeviceInfo);
    window.addEventListener('orientationchange', updateDeviceInfo);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateDeviceInfo);
      window.removeEventListener('orientationchange', updateDeviceInfo);
    };
  }, []);

  // Helper function to get optimal image size based on device
  const getOptimalImageSize = (baseWidth = 800) => {
    const { isMobile, isTablet, screenWidth, pixelRatio } = deviceInfo;

    let targetWidth;
    if (isMobile) {
      targetWidth = Math.min(screenWidth * pixelRatio, 600);
    } else if (isTablet) {
      targetWidth = Math.min(screenWidth * pixelRatio * 0.8, 1200);
    } else {
      targetWidth = Math.min(baseWidth * pixelRatio, 1600);
    }

    return Math.round(targetWidth);
  };

  return {
    ...deviceInfo,
    getOptimalImageSize
  };
};

export default useDeviceDetection;